import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useApiClient } from "@services/Api/ApiClientContext";
import { useSelectedEvent } from "@app/panel/Events/contexts/SelectedEvent.context";
import { useEventsModals } from "@app/panel/Events/contexts/EventsModals.context";
import { useSelectedSubmissions } from "@app/panel/Events/contexts/SelectedSubmissions.context";

import Portal from "@components/overlay/Portal/Portal";
import Backdrop from "@components/ux/Backdrop/Backdrop";
import Modal from "@components/overlay/Modal/Modal";
import Stack from "@components/arrangement/Stack/Stack";
import Group from "@components/arrangement/Group/Group";
import Button from "@components/dataEntry/Buttons/Button/Button";

import "./SendGroupTickets.scss";

const SendGroupTickets = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const { event } = useSelectedEvent();
  const { closeModal } = useEventsModals();
  const { selectedSubmissions, clearSelectedSubmissions } = useSelectedSubmissions();
  const { sendTickets } = useApiClient();

  const { t } = useTranslation(["eventsModals", "common"]);

  const handleSendGroupTickets = () => {
    if (selectedSubmissions.length <= 0) return;

    setSubmitting(true);

    sendTickets(event.id, selectedSubmissions)
      .then((res) => {
        if (res.status === 204) {
          closeModal();
          clearSelectedSubmissions();
        }
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Portal>
      <Backdrop open>
        <Modal onClose={closeModal}>
          <Stack className="send-group-tickets-modal">
            <p className="p0 mt-3">{t("eventsModals:sendGroupTickets.description")}</p>
            <Group colGap={10} className="mt-3" alignItems="flex-start">
              <img src="/images/icon-notification-info.svg" alt="send group tickets info" />
              <p className="p0">{t("eventsModals:sendGroupTickets.info")}</p>
            </Group>

            <Group colGap={20} className="mt-5">
              <Button type="submit" variant="primary" onClick={handleSendGroupTickets} disabled={submitting}>
                {t("common:send")}
              </Button>
              <Button variant="secondary" onClick={closeModal}>
                {t("common:cancel")}
              </Button>
            </Group>
          </Stack>
        </Modal>
      </Backdrop>
    </Portal>
  );
};

export default SendGroupTickets;
